


import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'


import getLocation from "@/components/getLocation";

import leLayer from "@/components/leLayer";

import detailPop from "@/components/detailPop";

import scenicPop from "@/components/scenicPop";

export default {
directives: {
TransferDom
},

components: {
getLocation,
leLayer,
Popup,
detailPop,
scenicPop
},
inject: ["reload"], //注入app.vue组件的依赖 当前页面改路由跳转用
data() {

return {


funImg: {
locationImgDefault: "", // 定位按钮
locationImgActive: "", // 定位按钮选中
searchImgDefault: "", // 搜索按钮
viewImgDefault: "", // 手绘按钮
viewImgActive: "", // 手绘按钮选中
lineImgDefault: "", // 线路按钮
lineImgActive: "", // 线路按钮选中
nearImgDefault: "", // 周边按钮
nearImgActive: "", // 周边按钮选中
funFull: {
img: "", //全景按钮
url: ""
},
funShop: {
img: "", //商城按钮
url: ""
},
funAct: {
img: "", //活动按钮
url: ""
},
funTicket: {
img: "", //门票按钮
url: ""
},
funTraffic: {
img: "", //交通按钮
url: ""
},
funComplaint: {
img: "", //投诉按钮
url: ""
},
funNotice: {
img: "", //公告按钮
url: ""
}
},




audioSrc: null,
playing: false, //音频播放中的状态
barWidth: 0, //已播放条的宽度值
dotLeft: 0, //进度点的left值



scenicData: null, //景区数据
mapObj: null, //地图实例
isLocation: false, //是否展示当前定位了
scenicBound: [], //景区电子围栏范围
hid: this.$route.query.hid ? this.$route.query.hid : 1156,
leLayer: null, //瓦片实例
isLelayerShow: true, //瓦片展示
poiType: null, //poi类别
isPoiTypeListShow: true, //周边列表是否展示
activePoiTypeId: 2, //当前展示的poi的typeid
activePoiTypeIndex: null, //当前展示的poi类型在PoiType中的下标
infoWindow: null, //信息窗体实例
mapMaxZoom: null, //地图最大层级
mapMinZoom: null, //地图最小层级
scenicZoom: null, //当前景区展示层级


curMarkerArr: null, //当前展示的markers
isLineShow: false, //线路是否展示
polyline: null, //线路的线的实体
lines: [
[
{
description: "",
imgurl: "",
lineLatLng: [],
lineMarkers: [],
lineName: "",
lineTime: "",
scenicNum: ""
}
]
], //线路点位
lineIndex: 0, //当前展示的线路的在所有线路集合中的下标
curLinePoiIndex: -1, //当前选中的线路 选中的点位的下标
lineVal: {
id: "",
is_guide: 0
},
curLine: {},






isDetailPopShow: false, //名宿等详情弹窗
details: {
imgList: [],
title: "",
address: "",
des: "",
mobile: "",
lat: "",
lng: "",
is_guide: false,
id: ""
},



isScenicPopShow: false,
scenicPopData: {}
};
},

computed: {},

watch: {
$route(to, from) {

this.refresh(); 

document.location.reload();
},
curLinePoiIndex(newV) {
if (newV == -1) {
console.log("隐藏线路音频");
this.audioEnded();
if (!document.getElementById("myaudio").paused) {

document.getElementById("myaudio").pause();
}
}
}
},

methods: {
refresh() {
this.reload();
},

getScenicData(hid) {
let that = this;
that.get({
url:
that.GLOBAL.BASE_URL + "/api/v1/map_view!GetSingleSecentWebs.action",
params: {
hid: hid 
},
isShowLoading: true,
success: function(data) {
console.log(data.data);
that.scenicData = data.data.data.data.scenic;
document.title = data.data.data.data.scenic.name;
that.mapMaxZoom = data.data.data.data.scenic.max_zoom;
that.scenicLng = data.data.data.data.scenic.longitude;
that.scenicLat = data.data.data.data.scenic.latitude;
that.mapMinZoom = data.data.data.data.scenic.min_zoom;
that.scenicZoom = data.data.data.data.scenic.rank;
let componentList = data.data.data.data.componentList;

for (let i in componentList) {
if (componentList[i].com_id == 23) {

that.funImg.viewImgDefault =
that.GLOBAL.DOMAIN_URL + componentList[i].icon;
that.funImg.viewImgActive =
that.GLOBAL.DOMAIN_URL + componentList[i].picth_icon;
} else if (componentList[i].com_id == 21) {

that.funImg.locationImgDefault =
that.GLOBAL.DOMAIN_URL + componentList[i].icon;
that.funImg.locationImgActive =
that.GLOBAL.DOMAIN_URL + componentList[i].picth_icon;
} else if (componentList[i].com_id == 22) {

that.funImg.searchImgDefault =
that.GLOBAL.DOMAIN_URL + componentList[i].icon;
} else if (componentList[i].com_id == 13) {

that.funImg.funFull.img =
that.GLOBAL.DOMAIN_URL + componentList[i].icon;
that.funImg.funFull.url = componentList[i].url;
} else if (componentList[i].com_id == 14) {

that.funImg.funShop.img =
that.GLOBAL.DOMAIN_URL + componentList[i].icon;
that.funImg.funShop.url = componentList[i].url;
} else if (componentList[i].com_id == 15) {

that.funImg.funComplaint.img =
that.GLOBAL.DOMAIN_URL + componentList[i].icon;
that.funImg.funComplaint.url = componentList[i].url;
} else if (componentList[i].com_id == 16) {

that.funImg.funTicket.img =
that.GLOBAL.DOMAIN_URL + componentList[i].icon;
that.funImg.funTicket.url = componentList[i].url;
} else if (componentList[i].com_id == 17) {

that.funImg.funTraffic.img =
that.GLOBAL.DOMAIN_URL + componentList[i].icon;
that.funImg.funTraffic.url = componentList[i].url;
} else if (componentList[i].com_id == 18) {

that.funImg.funNotice.img =
that.GLOBAL.DOMAIN_URL + componentList[i].icon;
that.funImg.funNotice.url = componentList[i].url;
} else if (componentList[i].com_id == 19) {

that.funImg.funAct.img =
that.GLOBAL.DOMAIN_URL + componentList[i].icon;
that.funImg.funAct.url = componentList[i].url;
} else if (componentList[i].com_id == 24) {

that.funImg.nearImgDefault =
that.GLOBAL.DOMAIN_URL + componentList[i].icon;
that.funImg.nearImgActive =
that.GLOBAL.DOMAIN_URL + componentList[i].picth_icon;
} else if (componentList[i].com_id == 25) {

that.funImg.lineImgDefault =
that.GLOBAL.DOMAIN_URL + componentList[i].icon;
that.funImg.lineImgActive =
that.GLOBAL.DOMAIN_URL + componentList[i].picth_icon;
}
}

that.setPoiType(data.data.data.data.hotTypeList);

that.setPois(that.scenicData.pointses);
that.setScenicPois(data.data.data.data.childHotspotList);

that.getMap();

that.setLine(that.scenicData.hotspotLinesList);
}
});
},

getMap() {
let that = this;

that.mapObj = new AMap.Map("container", {
view: new AMap.View2D({

center: new AMap.LngLat(that.scenicLng, that.scenicLat),
zoom: that.scenicZoom, //设置地图缩放级别
rotation: 0 
}),
resizeEnable: true,
zooms: [that.mapMinZoom, that.mapMaxZoom],
features: ["bg", "road", "building"],
lang: "zh_cn" 
});

for (let i in that.scenicData.polygons) {
that.scenicBound.push([
that.scenicData.polygons[i].longitude,
that.scenicData.polygons[i].latitude
]);
}



















that.curMarkerArr =
that.poiType[that.activePoiTypeIndex].poiArr[
that.mapObj.getZoom() - that.mapMinZoom
];

that.mapObj.add(that.curMarkerArr);

that.leLayer = new AMap.TileLayer({

tileUrl:




"https://pic2.worldmaipu.com/api/v1/tile!GetScenicTile.action?x=[x]&z=[z]&y=[y]&hid=" +
that.hid,
zIndex: 2
});
that.leLayer.setMap(that.mapObj);


that.isLocation = true; 
that.mapObj.on("complete", function() {});


AMap.event.addListener(that.mapObj, "zoomend", function() {

that.scenicZoom = that.mapObj.getZoom();
console.log("当前地图层级==" + that.mapObj.getZoom());

that.mapObj.clearInfoWindow();
that.mapMoveEnd();
});












that.mapObj.plugin(["AMap.ToolBar"], function() {
that.mapObj.addControl(
new AMap.ToolBar({
position: "RB",

liteStyle: true,
offset: new AMap.Pixel(10, 300)
})
);
});
},
mapMoveEnd() {
if (this.isLineShow) {
} else {
this.mapObj.remove(this.curMarkerArr);
this.addPoi();
}
},

setPois(arr) {
let that = this;

let poiZoomRange = that.mapMaxZoom - that.mapMinZoom;
for (let i in arr) {
if (arr[i].type != 1) {

if (arr[i].l_type == 1) {
let default_type_bg;
let icon_default; 
let icon_active; 
let typeIndex; 
let isHasThisType = false; 

for (let j in that.poiType) {
if (arr[i].type == that.poiType[j].id) {
default_type_bg = that.poiType[j].defaultBg;
icon_default = that.poiType[j].poiDefaultBg;
icon_active = that.poiType[j].poiActiveBg;
typeIndex = j;
isHasThisType = true;
that.poiType[j].isHasPoi = true; 
break;
}
}

if (!isHasThisType) {
console.log("点位类别没有类别type===" + arr[i].type);
continue;
}
let marker = new AMap.Marker({

position: new AMap.LngLat(arr[i].longitude, arr[i].latitude),

content:
"<div class='poi'><img class='iconall' id='poi" +
i +
"' src='" +
that.GLOBAL.DOMAIN_URL +
icon_default +
"'><span class='poiName'>" +
arr[i].chs_name +
"</span></div>",
offset: new AMap.Pixel(-15, -30),
extData: {








poiType: arr[i].type,
poiData: arr[i],
index: i,
default_type_bg: default_type_bg, //左侧分类的默认的图标 信息窗体中用
icon_default: icon_default, //poi的marker点的默认图标
icon_active: icon_active 
}
});

AMap.event.addListener(marker, "click", function(e) {
this.setTop(true);
let position = e.target.getPosition();
let extData = e.target.getExtData();
console.log(extData);
that.mapObj.setCenter(position);
if (extData.poiType == 2) {

let data = {
address: extData.poiData.address,
audio: extData.poiData.audio,
id: extData.poiData.hid,
is_guide: 0,
latitude_gcj: extData.poiData.latitude,
longitude_gcj: extData.poiData.longitude,
name: extData.poiData.chs_name,
thumb_img: extData.poiData.thumbImg
};
that.scenicPopData = data;
that.isScenicPopShow = true;
} else {
that.poiMarkerFun(extData, position);
}
});

let min = arr[i].min_zoom - that.mapMinZoom;
for (let z = 0; z < poiZoomRange + 1; z++) {
if (z >= min) {
that.poiType[typeIndex].poiArr[z].push(marker);
}
}
}
}
}

},

setScenicPois(arr) {
let that = this;

let poiZoomRange = that.mapMaxZoom - that.mapMinZoom;
for (let i in arr) {
let default_type_bg = that.poiType[0].defaultBg;
let icon_default = that.poiType[0].poiDefaultBg;
let icon_active = that.poiType[0].poiActiveBg;
that.poiType[0].isHasPoi = true;

let marker = new AMap.Marker({

position: new AMap.LngLat(arr[i].longitude_gcj, arr[i].latitude_gcj),

content:
"<div class='poi'><img class='iconall' id='poi" +
i +
"' src='" +
that.GLOBAL.DOMAIN_URL +
icon_default +
"'><span class='poiName'>" +
arr[i].hotspot_name +
"</span></div>",
offset: new AMap.Pixel(-15, -30),
extData: {








poiData: arr[i],
index: i,
default_type_bg: default_type_bg, //左侧分类的默认的图标 信息窗体中用
icon_default: icon_default, //poi的marker点的默认图标
icon_active: icon_active 
}
});

AMap.event.addListener(marker, "click", function(e) {
this.setTop(true);
let position = e.target.getPosition();
let extData = e.target.getExtData();
console.log(extData);
that.mapObj.setCenter(position);

let data = {
audio: extData.poiData.audio,
id: extData.poiData.hotspot_id,
is_guide: extData.poiData.is_guide,
latitude_gcj: extData.poiData.latitude_gcj,
longitude_gcj: extData.poiData.longitude_gcj,
name: extData.poiData.hotspot_name,
thumb_img: extData.poiData.thumb_img
};
that.scenicPopData = data;
that.isScenicPopShow = true;







});


for (let z = 0; z < poiZoomRange + 1; z++) {

that.poiType[0].poiArr[z].push(marker);

}
}
},

setLine(arr) {
let that = this;
let icon_default; 
let icon_active; 
that.lines = [];
console.log(arr);
if (!arr.length > 0) {
return;
}
for (let i in arr) {
let obj = {};
obj.description = arr[i].description;
obj.lineName = arr[i].lineName;
obj.lineTime = arr[i].reserved3;
obj.scenicNum = arr[i].reserved4;
obj.imgurl = arr[i].imgurl;
obj.lineLatLng = []; 
obj.lineMarkers = [];
obj.linePoiName = [];
let z = 1;
for (let j in arr[i].coordinateList) {
obj.lineLatLng.push(
new AMap.LngLat(
Number(arr[i].coordinateList[j].longitude),
Number(arr[i].coordinateList[j].latitude)
)
);

if (arr[i].coordinateList[j].reserved1.indexOf("默认") == -1) {
obj.linePoiName.push(arr[i].coordinateList[j].reserved1);
let marker = new AMap.Marker({

content: `<div class="line-markers" id="linePoi${z -
1}"><div class="line-marker"><span>${z}</span></div><div class="line-infobox" style="background-image:url('./static/img/go.gif');" id="lineInfo${z -
1}"><div class="line-info"><i class="info-close"></i><div class="line-infoTop"><img src="${that
.GLOBAL.DOMAIN_URL +
arr[i].coordinateList[j]
.thumb_img}"><div class="info-title-des"><div class="info-title ellipsis-1">${
arr[i].coordinateList[j].reserved1
}</div><div class="info-des">${
arr[i].coordinateList[j].intro
}</div></div><div class="info-more"></div></div><div class="info-go" data-name="${
arr[i].coordinateList[j].reserved1
}" data-lat="${arr[i].coordinateList[j].latitude}" data-lng="${
arr[i].coordinateList[j].longitude
}"><i class="icon-go"></i><div>到这里</div></div></div></div></div>`,
position: new AMap.LngLat(
arr[i].coordinateList[j].longitude,
arr[i].coordinateList[j].latitude
),

offset: new AMap.Pixel(-18, -36),
extData: {
name: arr[i].coordinateList[j].reserved1,
audio: arr[i].coordinateList[j].audio,
thumb_img: arr[i].coordinateList[j].thumb_img,
hid: arr[i].coordinateList[j].reserved2,
id: arr[i].coordinateList[j].id,
domId: "linePoi" + (z - 1),
index: z - 1


}
});
AMap.event.addListener(marker, "click", function(e) {
let thisPosition = e.target.getPosition();
let extData = e.target.getExtData();
that.curLinePoiIndex = extData.index;
this.setTop(true); 


that.scrollLeftTo(
document.getElementsByClassName("line-poi-item")[extData.index],
document.getElementById("linePois"),
extData.index
);

that.linePoiFun(extData, thisPosition);
});

obj.lineMarkers.push(marker);
z++;
}
}
that.lines.push(obj);
}
console.log(that.lines);
},
openLineDetail() {

let audio = document.getElementById("myaudio");

if (!audio.paused) {

audio.pause();
this.playing = false;
}
this.getScenicDetailFromScenicPop(this.lineVal);
},

scrollLeftTo(element, elementFather, index) {
let actualLeft = element.offsetLeft;
let current = element.offsetParent;
actualLeft += current.offsetLeft;
current = current.offsetParent;
elementFather.scrollLeft = actualLeft - element.clientWidth * 2;
},

showLine() {
if (this.isLineShow) {
this.isLineShow = !this.isLineShow;
this.mapObj.remove(this.curMarkerArr);
this.mapObj.remove(this.polyline);
this.polyline = null;
this.curLinePoiIndex = -1;
document.getElementById("linePois").scrollLeft = 0;



this.addPoi();
} else {
this.isScenicPopShow = false;
this.isLineShow = !this.isLineShow;



this.mapObj.remove(this.curMarkerArr);
this.curMarkerArr = this.lines[this.lineIndex].lineMarkers;
this.mapObj.add(this.curMarkerArr);
if (
this.polyline == "" ||
this.polyline == undefined ||
this.polyline == null
) {
this.polyline = new AMap.Polyline({
path: this.lines[this.lineIndex].lineLatLng, //设置线覆盖物路径
strokeColor: "#f56b61", //线颜色
strokeOpacity: 0.8, //线透明度
strokeWeight: 3, //线宽
strokeStyle: "solid", //线样式
isOutline: true,
borderWeight: 1,
outlineColor: "#fff",
lineJoin: "round",
lineCap: "round",
strokeDasharray: [10, 5], //补充线样式
zIndex: 9999
});
this.polyline.setMap(this.mapObj);
} else {
this.mapObj.remove(this.polyline);
}
this.mapObj.setFitView();
}
},

changeLine(i) {
if (i == this.lineIndex) {
return;
} else {
this.lineIndex = i;
this.curLinePoiIndex = -1; 
document.getElementById("linePois").scrollLeft = 0;
this.mapObj.remove(this.curMarkerArr);
if (this.polyline != null) {
this.mapObj.remove(this.polyline);
this.polyline = null;
}
this.polyline = new AMap.Polyline({
path: this.lines[this.lineIndex].lineLatLng, //设置线覆盖物路径
strokeColor: "#f56b61", //线颜色
strokeOpacity: 0.8, //线透明度
strokeWeight: 3, //线宽
strokeStyle: "solid", //线样式
isOutline: true,
borderWeight: 1,
outlineColor: "#fff",
lineJoin: "round",
lineCap: "round",
strokeDasharray: [10, 5], //补充线样式
zIndex: 9999
});
this.polyline.setMap(this.mapObj);
this.curMarkerArr = this.lines[this.lineIndex].lineMarkers;
this.mapObj.add(this.curMarkerArr);
this.mapObj.setFitView();
}
},

changeCurLinePoiIndex(i) {
if (i == this.curLinePoiIndex) {
return;
} else {
this.curLinePoiIndex = i;
let marker = this.lines[this.lineIndex].lineMarkers[i];
marker.setTop(true); 

this.scrollLeftTo(
document.getElementsByClassName("line-poi-item")[
marker.getExtData().index
],
document.getElementById("linePois"),
marker.getExtData().index
);

this.linePoiFun(marker.getExtData(), marker.getPosition());
}
},

linePoiFun(data, position) {
let that = this;
console.log(data);
console.log(position);
that.lineVal.id = data.hid;

this.mapObj.setCenter(position);

if (document.getElementsByClassName("markerOn")[0] != undefined) {
document
.getElementsByClassName("markerOn")[0]
.classList.remove("markerOn");
}
let classVal = document.getElementById(data.domId).getAttribute("class");
classVal = classVal.concat(" markerOn");
document.getElementById(data.domId).setAttribute("class", classVal);
let audio = document.getElementById("myaudio");
that.audioSrc =
that.GLOBAL.DOMAIN_URL + data.audio.split(".")[0] + ".mp3";
audio.load();
that.playing = false;
this.barWidth = 0;
this.dotLeft = 0;

if (that.GLOBAL.isWx) {
if (window.WeixinJSBridge) {
WeixinJSBridge.invoke(
"getNetworkType",
{},
function(e) {
that.audioPlay();
},
false
);
} else {
document.addEventListener(
"WeixinJSBridgeReady",
function() {
WeixinJSBridge.invoke("getNetworkType", {}, function(e) {
that.audioPlay();
});
},
false
);
}
} else {

}

document
.getElementById(data.domId)
.getElementsByClassName("info-close")[0]

.addEventListener(
"touchstart",
function() {
that.curLinePoiIndex = -1;

document
.getElementsByClassName("markerOn")[0]
.classList.remove("markerOn");
},
false
);

document
.getElementById(data.domId)
.getElementsByClassName("info-go")[0]

.addEventListener(
"touchstart",
function() {
console.log("高德导航");
let name = this.getAttribute("data-name");
let lat = this.getAttribute("data-lat");
let lng = this.getAttribute("data-lng");
that.commonFun.openLocation(
name,
sessionStorage.getItem("lat"),
sessionStorage.getItem("lng"),
lat,
lng
);
},
false
);

document
.getElementById(data.domId)
.getElementsByClassName("info-title-des")[0]

.addEventListener(
"touchstart",
function() {
that.openLineDetail();
},
false
);
},

setPoiType(arr) {
let that = this;
that.poiType = [];
for (let i in arr) {
let obj = {};
obj.id = arr[i].points_type_id;
obj.name = arr[i].type_name;
obj.defaultBg = arr[i].icon;
obj.activeBg = arr[i].picth_icon;
obj.poiDefaultBg = arr[i].point_icon;
obj.poiActiveBg = arr[i].point_picth_icon;
obj.poiArr = [];
obj.isHasPoi = false; 
if(arr[i].points_type_id==2){
that.activePoiTypeIndex=i
}
for (let j = that.mapMinZoom; j <= that.mapMaxZoom; j++) {
obj.poiArr.push([]);
}
that.poiType.push(obj);
}
console.log(that.poiType);
},

changePoiType(typeId, i) {
console.log("changePoiType");
let that = this;

if (this.isLineShow) {






that.$vux.toast.text("请先退出线路", "bottom");
return;
} else {
if (typeId == that.activePoiTypeId) {












return;
} else {
that.mapObj.clearInfoWindow();
that.activePoiTypeId = typeId;
that.activePoiTypeIndex = i;
that.mapObj.remove(this.curMarkerArr);
that.addPoi();
that.isScenicPopShow = false;
}
}
},

poiMarkerFun(data, position) {
let that = this;
if (data.poiData.type == 2) {

that.$router.push({
path: "/scenicPoiDetail",
name: "scenicPoiDetail",
query: { hid: data.poiData.hid }
});
} else {
let distance = (
this.commonFun.getGreatCircleDistance(
sessionStorage.getItem("lat"),
sessionStorage.getItem("lng"),
position.lat,
position.lng
) / 1000
).toFixed(2);
let title =
"<img src='" +
that.GLOBAL.DOMAIN_URL +
data.default_type_bg +
"' /><span>" +
distance +
"km</span>";

let middle =
"<div id='infoNav' data-name='" +
data.poiData.chs_name +
"' data-lat='" +
position.lat +
"' data-lng='" +
position.lng +
"'><i></i><span>到这里</span></div>";


this.infoWindow = new AMap.InfoWindow({
isCustom: true, //使用自定义窗体
content: this.createInfoWindow(title, middle),
offset: new AMap.Pixel(0, -34)
});
this.infoWindow.open(this.mapObj, position);

setTimeout(() => {
that.mapObj.setCenter([position.lng, position.lat]);
document.getElementById("infoNav").addEventListener(
"click",
function() {
console.log("高德导航");
let name = this.getAttribute("data-name");
let lat = this.getAttribute("data-lat");
let lng = this.getAttribute("data-lng");
that.commonFun.openLocation(
name,
sessionStorage.getItem("lat"),
sessionStorage.getItem("lng"),
lat,
lng
);
},
false
);
}, 50);
}
},

createInfoWindow(title, mContent) {
var info = document.createElement("div");
info.className = "content-window-card";

var top = document.createElement("div");

top.className = "info-top vux-1px-b";
top.innerHTML = title;
info.appendChild(top);

var middle = document.createElement("div");
middle.className = "info-middle";
middle.innerHTML = mContent;
info.appendChild(middle);








return info;
},
addPoi() {

this.curMarkerArr = this.poiType[this.activePoiTypeIndex].poiArr[
this.mapObj.getZoom() - this.mapMinZoom
];
this.mapObj.add(this.curMarkerArr);
},

changeDetailPop(val) {
this.isDetailPopShow = val;
this.details = {
imgList: [],
title: "",
address: "",
des: "",
mobile: "",
lat: "",
lng: "",
is_guide: false,
id: ""
}; //清空详情组件的details props
},

changeScenicPop(val) {
this.isScenicPopShow = val;

},

getScenicDetailFromScenicPop(val) {
let that = this;

that.get({
url: that.GLOBAL.BASE_URL + "/api/v1/map_view!detail.action",
params: { hid: val.id },
isShowLoading: false,
success: function(data) {
console.log(data.data.data);
let details = {};
details.is_guide = val.is_guide;
details.id = data.data.data.hotspot.id;
details.imgList = [];
for (let i in data.data.data.imgList) {
details.imgList.push(
that.GLOBAL.DOMAIN_URL + data.data.data.imgList[i].midImg
);
}

details.title = data.data.data.hotspot.name;
details.address = data.data.data.hotspot.address;
details.des = data.data.data.hotspot.description;
details.mobile = "";
details.lat = data.data.data.hotspot.latitudeGCJ + "";
details.lng = data.data.data.hotspot.longitudeGCJ + "";
if (data.data.data.hotspot.audio != null) {
details.audio =
that.GLOBAL.DOMAIN_URL +
data.data.data.hotspot.audio.split(".")[0] +
".mp3";
}

that.details = details;
}
});
this.isScenicPopShow = false;
this.isDetailPopShow = true;
},

isPTListShow() {
this.isPoiTypeListShow = !this.isPoiTypeListShow;








},


progressBarBg(e) {
let audio = document.getElementById("myaudio");
if (!audio.paused || audio.currentTime != 0) {

let pgsWidth = document.getElementsByClassName("progress-bar-bg")[0]
.offsetWidth;
let rate = e.offsetX / pgsWidth;
audio.currentTime = audio.duration * rate;
this.updateProgress(audio);
}
},



progressDot(e) {
let that = this;
let audio = document.getElementById("myaudio");
let dot = document.getElementById("progressDot");
if (!audio.paused || audio.currentTime != 0) {
let oriLeft = dot.offsetLeft;
let mouseX = e.clientX;
let maxLeft = oriLeft; 
let maxRight =
document.getElementById("progressBarBg").offsetWidth - oriLeft; 


if (e.preventDefault) {
e.preventDefault();
} else {
e.returnValue = false;
}


if (e && e.stopPropagation) {
e.stopPropagation();
} else {
window.event.cancelBubble = true;
}


document.onmousemove = function(e) {
let length = e.clientX - mouseX;
if (length > maxRight) {
length = maxRight;
} else if (length < -maxLeft) {
length = -maxLeft;
}
let pgsWidth = document.getElementsByClassName("progress-bar-bg")[0]
.width;
let rate = (oriLeft + length) / pgsWidth;
audio.currentTime = audio.duration * rate;
that.updateProgress(audio);
};


document.onmouseup = function() {
document.onmousemove = null;
document.onmouseup = null;
};
}
},

audioPlay() {
console.log("click");
let that = this;
let audio = document.getElementById("myaudio");

audio.addEventListener(
"timeupdate",
function() {
that.updateProgress(audio);
},
false
);


audio.addEventListener(
"ended",
function() {
that.audioEnded();
},
false
);


if (audio.paused) {

audio.play();
that.playing = true;
} else {
audio.pause();
that.playing = false;
}
},

updateProgress(audio) {
console.log("同步进度条");
let value = audio.currentTime / audio.duration;
this.barWidth = value * 100;
this.dotLeft = value * 100;


},

audioEnded() {
this.barWidth = 0;
this.dotLeft = 0;
this.playing = false;

},

openOutUrl(url) {
window.location.href = url;
}
},

created() {
this.getScenicData(this.hid);
},

mounted() {
console.log(this.$route.query);
},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};



// WEBPACK FOOTER //
// ./src/pages/map.vue